import React from "react";
import BaseEdge, { roundTo } from "./BaseEdge";

// Smooth S-curve spline using cubic bezier.
export default function SplineEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  color,
}) {
  const from = nodeById[edge.from];
  const to = nodeById[edge.to];
  if (!from || !to) return null;

  const src = {
    x: roundTo(from.x + from.width / 2),
    y: roundTo(from.y + from.height / 2),
  };

  const dst = {
    x: roundTo(to.x + to.width / 2),
    y: roundTo(to.y + to.height / 2),
  };

  const mx = (src.x + dst.x) / 2;
  const my = (src.y + dst.y) / 2;

  // Control points for S-curve
  const c1 = {
    x: src.x + (mx - src.x) * 0.6,
    y: src.y,
  };

  const c2 = {
    x: dst.x - (dst.x - mx) * 0.6,
    y: dst.y,
  };

  const d = `M ${src.x} ${src.y} C ${c1.x} ${c1.y} ${c2.x} ${c2.y} ${dst.x} ${dst.y}`;

  const labelPos = {
    x: mx,
    y: my - 12,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
